import * as MobileStepbarStyles from './components/MobileStepbar.css';
import * as StepStyles from './components/Step/Step.css';
import * as StepContentStyles from './components/StepContent/StepContent.css';
export default {
    MobileStepbarStyles: MobileStepbarStyles,
    StepStyles: StepStyles,
    StepContentStyles: StepContentStyles
};
